import { Pipe, PipeTransform } from '@angular/core';
import { CompanyContext, companyCommands } from '@app/model';

/** The route of a company in a context, for a routerLink of a table row. */
@Pipe({ name: 'companyLink', standalone: false })
export class CompanyLinkPipe implements PipeTransform {
  transform(
    companyId: string,
    context: CompanyContext | null,
    tab = 'overview'
  ): string[] {
    return companyCommands(companyId, tab, context);
  }
}
